import types from './umkdTypes'

const setDirectionTraining = (items: []) => ({ type: types.UMKD_SET_DIRECTION_TRAINIG, items })
const setSpecialization = (items: []) => ({ type: types.UMKD_SET_SPECIALIZATION, items })
const setSubjects = (items: []) => ({ type: types.UMKD_SET_SUJECTS, items })
const setFiles = (items: []) => ({ type: types.UMKD_SET_FILES, items })

const umkdActions = {
    setDirectionTraining, // Загрузка направлений подготовки
    setSpecialization, // Загрузка специализаций
    setSubjects, // Загрузка дисциплин
    setFiles, // Загрузка предметов
}

export default umkdActions